import { makeStyles } from '@material-ui/core'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    height: 478,
    maxHeight: 478,
    width: 335,
    overflowY: 'hidden',
    [theme.breakpoints.down(400)]: {
      height: 'calc(100dvh - 196px)',
      width: 300,
    },
  },
  emailButton: {
    width: '-webkit-fill-available',
  },
  tabScroll: {
    overflowY: 'auto',
    height: 443,
    maxHeight: 443,
    width: '100%',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 230px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabContain: {
    overflowY: 'hidden',
    height: '430px',
  },
  collapse: {
    height: 'auto',
    flexShrink: '0',
  },
  eventIconDot: {
    fontSize: '12px',
    transform: 'scale(1) translate(-50%, 50%)',
    color: theme.palette.base.red,
  },
  modalTabs: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  moveCalendar: {
    marginTop: '-100px',
    marginBottom: '-30px',
    zIndex: '0',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(400)]: {
      scale: '0.9',
      marginTop: '-111px',
      marginLeft: theme.spacing(-1),
    },
  },
  eventsHolder: {
    padding: '0px 10px',
  },
  eventScroll: {
    transition: 'all 1s ease',
    zIndex: '1',
  },
  dayView: {
    transition: 'all 1s ease',
    zIndex: '1',
    transform: 'translate(0, 10px)',
  },
  fullWidth: {
    width: '-webkit-fill-available',
  },
  badge: {
    color: theme.palette.base.red,
  },
  icon: {
    color: theme.palette.base.gray,
    fontSize: 40,
    '&:hover': {
      transform: 'scale(1.07)',
    },
  },
  headerText: {
    paddingLeft: '7px',
  },
  monthAndYear: {
    width: 'min-content',
    paddingBottom: '8px !important',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '6px !important',
    },
  },
  bellIcon: {
    color: theme.palette.base.red,
    fontSize: theme.typography.h2.fontSize,
    marginBottom: '-28px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-28px',
    },
  },
  dayOverlay: {
    color: theme.palette.base.white,
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down(769)]: {
      marginTop: theme.spacing(0.25),
    },
  },
  dayOverlayHolder: {
    width: 'min-content',
    paddingBottom: '18px !important',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '12px !important',
    },
  },
  eventsCard: {
    margin: '5px',
  },
  eventHeader: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  calendarDivider: {
    width: '-webkit-fill-available',
    zIndex: '1',
  },
  eventCard: {
    padding: '5px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  emailAndCalendarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  emailAndCalendarContainerColor: {
    width: '90%',
    background: theme.palette.base.green,
    padding: 10,
    marginTop: 20,
    borderRadius: '0.5rem',
  },
  googleSignInContainer: {
    width: '90%',
    margin: 'center',
    marginTop: 20,
  },
  emailAndCalendarText: {
    color: theme.color.almostBlack,
  },
  conferenceButton: {
    wordWrap: 'break-word',
    marginBottom: 10,
    '&:hover': {
      color: theme.palette.base.white,
    },
  },
  quickLinks: {
    overflowY: 'auto',
    height: 'calc(100dvh - 230px)',
    paddingTop: theme.spacing(3),
  },
  resetWidgetGrid: {
    textAlign: 'center',
    margin: theme.spacing(1, 0),
  },
}))

export default styles
